import { render } from "./Item3.vue?vue&type=template&id=3ba5b456&ts=true"
import script from "./Item3.vue?vue&type=script&lang=ts"
export * from "./Item3.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__